import React, { useEffect, useRef } from 'react'

import { CFormTextarea } from '@coreui/react-pro'
import autosize from 'autosize'

import { ICFormTextareaAutoResize } from '@interfaces/components/atoms/CFormTextareaAutoResize'

const CFormTextareaAutoResize: React.FC<ICFormTextareaAutoResize> = (props) => {
  const inputRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    if (inputRef.current) {
      autosize(inputRef.current)
    }
  }, [])

  useEffect(() => {
    if (inputRef.current) {
      autosize.update(inputRef.current)
    }
  }, [props.value])

  return <CFormTextarea {...props} ref={inputRef} />
}

export default CFormTextareaAutoResize
